<template>
<div>
    <div class="netwrking-wrapper" style="width:100%;background:white">
      <h2 class="networking-heading">{{$t('networking.networkingTitle')}}</h2>
      <p class="networking-sub">{{ usersCount }} {{$t('networking.resultsFound')}}</p>
      <a-tabs default-active-key="1" class="networking-tabs" @change="setTab">
        <a-tab-pane key="1" :tab="$t('networking.participants')">
          <a-card class="networking-card">
            <each-user-row v-for="(user, index) in users" 
              :key="index"
              :user="user"
            >
            </each-user-row>
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('networking.networkingRooms')">
            <a-card class="networking-card" v-if="meetings">
              <each-room-row v-for="(meeting, index) in meetings" 
              :key="index"
              :meeting="meeting"
            >
            </each-room-row>
            </a-card>
            <a-card class="networking-card" v-else>
              <p>{{$t('networking.noMeetings')}}</p>
            </a-card>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="networking-tabs" style="height:70px;width:100%" v-if="activeTab == 1">
      <pagination
        :pageCount="pageCount"
        :pageNumber="pageNumber"
        @page-change="updatePageAndGetUsers"
      />
    </div>
</div>
</template>

<script>
import api from '@/api'
import axios from 'axios';
import Pagination from '../components/admin/Pagination'
import EachUserRow from '../components/list-of-attendees/EachUserRow'
import EachRoomRow from '../components/list-of-attendees/EachRoomRow'

export default {
  components: {
    EachUserRow,
    Pagination,
    EachRoomRow
  },
  data () {
    return {
      users: [],
      countries: [],
      questionFilters: [],
      filters: [],
      pageNumber: 1,
      pageCount: 0,
      limit: 5,
      usersCount: 0,
      cntIdArray: [],
      city: '',
      searchTimeout: null,
      openedDropdownId: null,
      meetings: [],
      activeTab: 1,
    }
  },
  created () {
    this.init();
  },
  watch: {
    city: {
      handler () {
        if (this.searchTimeout) {
          clearInterval(this.searchTimeout);
          this.searchTimeout = null;
        }
        this.searchTimeout = setTimeout(() => {
          this.getAttendees();
          this.getUserCountAndSetPageCount();
          this.searchTimeout = null;
        }, 500);
      },
    }
  },
  methods: {
    async init () {
      this.startLoading()
      await this.getAttendees(); 
      await this.getUserCountAndSetPageCount();
      await this.listBBBMeetings();
        this.interval = setInterval(() => this.listBBBMeetings(), 10000);
      this.stopLoading()
    },
    async listBBBMeetings(){
      const parseString = require('xml2js').parseString;
      let meetings = [];
      let url = 'https://hrweek.collectivibe.com/api/users/bbblist';
       await axios.get(url).then((response) => {
         parseString(response.data, function (err, result) {
            meetings = result.response.meetings[0].meeting;
          });        
         });
      this.meetings = meetings;
    },
    async getAttendees () {
      let apiObj = {
        api: api.getAttendees,
        params: {
          limit: this.limit,
          offset: (this.pageNumber - 1) * this.limit
        },
        onError: this.stopLoading
      }

      const data = await this.apiCall(apiObj);
        if (data.result) {
          this.users = data.result;
        } else {
          this.users = [];
        }
      this.stopLoading();
    },
    setTab(tabID){
      this.activeTab = tabID;
    },
    async getUserCountAndSetPageCount () {
      let apiObj = {
        api: api.getAttendeeCount,
        params: {
          limit: this.limit,
          offset: (this.pageNumber - 1) * this.limit
        },
        onError: this.stopLoading
      }
      
        const data = await this.apiCall(apiObj);
        this.usersCount = data.count;
        this.pageCount = Math.ceil(data.count / this.limit);
      this.stopLoading();
    },
    updatePageAndGetUsers (page) {
      this.pageNumber = page;
      this.getAttendees();
      if (window.innerWidth < 1366) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    setOpened (id) {
      this.openedDropdownId = id;
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
input {
  outline: none;
}
.page.has-footer{
  background: #F4F5F7;
}
.attendees-wrapper {
  padding: 30px 70px 30px 100px !important;
}
.not-found {
  padding-left: 20px;
}
.dropdown-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  > * {
    margin-right: 20px;
    margin-bottom: 30px;
  }
  .city {
    width: 180px;
    display: flex;
    align-items: center;
    input {
      //Hack za firefox
      min-width: 0
    }
  }
}
.users {
  position: relative;
  min-height: 66vh;
  padding-bottom: 60px;
}
.pagination {
  position: relative;
  width: 100%;
  max-width: 1220px;
  margin:auto;
  background: transparent;
}

@media (max-width: 1366px) {
  .pagination {
    width: 100%;
  }
}

@media (max-width: 588px) {
  .attendees-wrapper {
    padding: 5px 20px 0 20px !important;
  }
}
</style>